// import { contract_address } from "config";
// import { contract_abi } from "config";
// import React, { useEffect, useState } from "react";
// import { NotificationManager } from "react-notifications";
// import { useSelector } from "react-redux";
// import Web3 from "web3";
// import {
//   getInfoStaking,
//   staking,
//   getInfoUser,
//   addTree,
//   checkApproveStaking,
//   submitApproveStaking,
//   unStaking,
//   withdraw
// } from "service";
// import Countdown from 'react-countdown';



// const LoadingButton = ({ className }) => {
//   return (
//     <button className={className}>
//       <div className="spinner-border spinner-border-sm" role="status">
//         <span className="sr-only">Loading...</span>
//       </div>
//     </button>
//   );
// };

// const Staking = (props) => {
//   const state = useSelector((state) => state);
//   const [loading, setLoading] = useState(false);
//   const [profit, setProfit] = useState(0);
//   const [approve, setApprove] = useState(false);
//   const [packageStaking, setPackageStaking] = useState({});
//   const [BNB, setBNB] = useState(0);
//   const [SFT, setSFT] = useState(0);
//   const [balance, setBalance] = useState(0);
//   const [countdownKey, setCountdownKey] = useState(0);

//   const [price, setPrice] = useState({
//     symbolPrice: 0,
//     priceSFT: 0,
//     priceBNB: 0,
//     bnb: 0,
//   });

//   // useEffect(() => {
//   //   getData();
//   //   setInterval(() => {
//   //     getData();
//   //   }, 1000);
//   // }, []);

//   useEffect(() => {
//     console.log(state.user);

//   }, [state.user]);

//   const getData = async () => {
//     const infoStaking = await getInfoStaking();
//     const checkApp = await checkApproveStaking();
//     if (!infoStaking) {
//       return
//     }
//     let { timeClaim, sttReceive, _stake } = infoStaking;

//     setApprove(checkApp.stt);
//     setBalance(checkApp.balance);
//     let obj = {};

//     obj.timeClaim = timeClaim;
//     obj.sttReceive = sttReceive;
//     obj.amount = Number(_stake.amount) / 1e18;
//     obj.received = Number(_stake.received) / 1e18;
//     obj.timestamp = Number(_stake.timestamp);
//     obj.pt = Number(_stake.pt);
//     let times = Math.floor(Date.now() / 1000) - obj.timestamp;
//     obj.profit = (obj.amount * times * obj.pt / 259200000) - obj.received;
//     if (obj.amount == 0) {
//       obj.pt = 0
//     }
//     // console.log(obj, checkApp);
//     setPackageStaking(obj)
//   };


//   const onConfirmSFT = async () => {
//     setLoading(true);
//     let data = await staking(SFT);
//     // console.log(data);
//     if (!data) {
//       NotificationManager.error("Error", "Error", 10000);
//     } else {
//       NotificationManager.success("Investment Success", "Success", 10000);
//     }
//     setLoading(false);
//     getData();
//   }

//   const _approve = async () => {
//     setLoading(true);
//     let data = await submitApproveStaking();
//     // console.log(data);
//     if (!data) {

//     }

//     setLoading(false);
//     getData();
//   }

//   const onClaim = async () => {
//     setLoading(true);
//     let data = await withdraw();
//     console.log(data);
//     if (!data) {
//       NotificationManager.error("Error", "Error", 10000);
//     } else {
//       NotificationManager.success("Withdraw Success", "Success", 10000);
//     }

//     setLoading(false);
//     getData();
//   }

//   const _unStaking = async () => {
//     // window.location.replace('/info')
//     setLoading(true);
//     let data = await unStaking();
//     console.log(data);
//     if (!data) {
//       NotificationManager.error("Error", "Error", 10000);
//     } else {
//       NotificationManager.success("Success", "Error", 10000);
//     }

//     setLoading(false);
//     getData();
//   }

//   useEffect(() => {
//     // Xử lý khi giá trị timeClaim thay đổi
//     if (packageStaking.timeClaim) {
//       // Tăng giá trị countdownKey để kích hoạt việc render lại Countdown component
//       setCountdownKey(prevKey => prevKey + 1);
//     }
//   }, [packageStaking.timeClaim]);

//   const max = () => {
//     console.log(balance);
//     setSFT(balance)
//   }

//   return (
//     <div className="site-main-content__buy-sft">
//       <div className="container">

//         {/* <div className="manage-your-token-title">
//           <h3 className="main-title">Staking</h3>
//         </div>
//         <div className="row">
//           <div className="col col-12 col-sm-6">
//             <div className="block-item item-swap-rates">
//               <div className="block-item__wrap">
//                 <div className="block-item__content">
//                   <div className="buy-sft">
//                     <div className="row">
//                       <p>Balance LPs: {balance.toFixed(2)}</p>
//                       <div className="buy-sft-field col col-12">
//                         <input
//                           type="text"
//                           className="form-control"
//                           placeholder="0"
//                           onChange={(e) => {
//                             setSFT(Number(e.target.value));
//                           }}
//                           value={SFT}
//                         />
//                         <span onClick={max} style={{ cursor: 'pointer' }} className="unit">Max</span>
//                       </div>
//                     </div>
//                     {
//                       approve ? <div className="buy-sft-action text-center">
//                         {loading ? (
//                           <LoadingButton className="btn btn-primary" />
//                         ) : (
//                           <button
//                             className="btn btn-primary"
//                             onClick={onConfirmSFT}
//                           >
//                             Investment
//                           </button>
//                         )}
//                       </div>
//                         :
//                         < div className="buy-sft-action text-center">
//                           {loading ? (
//                             <LoadingButton className="btn btn-primary" />
//                           ) : (
//                             <button
//                               className="btn btn-primary"
//                               onClick={_approve}
//                             >
//                               Approve
//                             </button>
//                           )}
//                         </div>
//                     }
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col col-12 col-sm-6">
//             <div className="block-item item-swap-rates">
//               <div className="block-item__wrap">
//                 <div className="block-item__content">
//                   <div className="buy-sft">
//                     <div className="row">
//                       <div className="mb-4">Note: </div>
//                       <p>* Please long Claim before using this function!</p>
//                     </div>
//                     <div className="buy-sft-action text-center">
//                       {loading ? (
//                         <LoadingButton className="btn btn-primary" />
//                       ) : (
//                         <button
//                           className="btn btn-primary"
//                           onClick={() => {
//                             _unStaking();
//                           }}
//                         >
//                           Un Stake
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row">
//           <div className="col col-12 col-md-3">
//             <div className="block-item item-manage-your-token">
//               <div className="block-item__wrap text-center">
//                 <h3 className="block-item__title">% you can claim</h3>
//                 <div className="block-item__content">
//                   <h3>
//                     <span className="amount">
//                       30
//                     </span>
//                     %
//                   </h3>
//                 </div>
//                 <div className="block-item__footer">Per month</div>
//               </div>
//             </div>
//           </div>
//           <div className="col col-12 col-md-3">
//             <div className="block-item item-manage-your-token">
//               <div className="block-item__wrap text-center">
//                 <h3 className="block-item__title">LPs bought</h3>
//                 <div className="block-item__content">
//                   <h3>
//                     <span className="amount">
//                       {Number(packageStaking?.amount || 0).toFixed(2)}
//                     </span>
//                   </h3>
//                 </div>
//                 <div className="block-item__footer">LPs</div>
//               </div>
//             </div>
//           </div>
//           <div className="col col-12 col-md-3">
//             <div className="block-item item-manage-your-token">
//               <div className="block-item__wrap  text-center">
//                 <h3 className="block-item__title">Co2 claimed</h3>
//                 <div className="block-item__content">
//                   <h3>
//                     <span className="amount">
//                       {Number(packageStaking?.received || 0).toFixed(
//                         6
//                       )}
//                     </span>
//                   </h3>
//                 </div>
//                 <div className="block-item__footer">Co2</div>
//               </div>
//             </div>
//           </div>
//           <div className="col col-12 col-md-3">
//             <div className="block-item item-manage-your-token">
//               <div className="block-item__wrap text-center">
//                 <h3 className="block-item__title">Time remaining to Claim</h3>
//                 <div className="block-item__content">
//                   <h3>
//                     <span className="amount">

//                       <span className="amount">
//                         <Countdown key={countdownKey} date={packageStaking?.timeClaim * 1000 + 1200000} />
//                       </span>
//                     </span>
//                   </h3>
//                 </div>
//                 <div className="block-item__footer">
//                   {loading ? (
//                     <LoadingButton className="btn btn-primary" />
//                   ) : (
//                     <button
//                       type="submit"
//                       className="btn btn-primary btn-claim"
//                       onClick={onClaim}
//                       disabled={!packageStaking?.sttReceive}
//                     >
//                       CLAIM
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div> */}
//       </div>
//     </div >
//   );
// };

// export default Staking;



import { contract_address } from "config";
import { contract_abi } from "config";
import React, { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import Web3 from "web3";
import {
  getInfoStaking,
  staking,
  getInfoUser,
  addTree,
  checkApproveStaking,
  submitApproveStaking,
  unStaking,
  withdraw,
  formatNumber,
  getF1User,
  getTree,
  shortText
} from "service";
import Countdown from 'react-countdown';
import "./VotePage.css";
import "./TreeNode.css";

const LoadingButton = ({ className }) => {
  return (
    <button className={className}>
      <div className="spinner-border spinner-border-sm" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </button>
  );
};

const TreeNode = ({ node }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="tree-node">
      <div className="node-box">
        <div>🔗 {shortText(node.address)}</div>
        <div>Sponsor: {shortText(node.sponsor)}</div>
        <div>Members: {node.total_members}</div>
        <div>Bonus: ${formatNumber(node?.total_receive / 1e18)}/${formatNumber(node?.amount * 3 / 1e18)}</div>
        <button onClick={() => setExpanded(!expanded)} className="toggle-btn">
          {expanded ? "−" : "+"}
        </button>
      </div>
      {expanded && node.children?.length > 0 && (
        <div className="children">
          {node.children.map((child, index) => (
            <TreeNode key={index} node={child} />
          ))}
        </div>
      )}
    </div>
  );
};

const Staking = (props) => {
  const state = useSelector((state) => state);
  // const [currentLevel, setCurrentLevel] = useState(0);
  const [newLevel, setNewLevel] = useState(1);
  const totalPrice = newLevel * 40;
  const user = useSelector((state) => state.user);
  const [sttApprove, setSttApprove] = useState(false);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dataF1, setDataF1] = useState([]);
  const [treeData, setTreeData] = useState([]);

  useEffect(async () => {
    // console.log(user);
    let data = await getF1User();
    // console.log(data);
    if (data) {
      let arr = [];

      for (let index = 0; index < data.f1Addresses.length; index++) {
        arr.push({
          amounts: data.amounts[index],
          commissions1: data.commissions1[index],
          commissions2: data.commissions2[index],
          f1Addresses: data.f1Addresses[index],
          rewards: data.rewards[index],
          totalReceives: data.totalReceives[index],
        })
      }
      setDataF1(arr)
    }
  }, [user]);

  useEffect(async () => {
    // Replace this with real data from contract call
    // setTreeData(mockTreeData);
    if (window.localStorage.getItem('dataTree')) {
      let dt = JSON.parse(window.localStorage.getItem('dataTree'))
      console.log(dt);
      let arr = []
      arr.push(dt)
      setTreeData(arr);
    }
    let data = await getTree();
    console.log(data);

    if (data) {
      window.localStorage.setItem('dataTree', JSON.stringify(data))
      let arr = []
      arr.push(data)
      setTreeData(arr);
    }
  }, []);

  const intervalRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {

        let stt = window.localStorage.getItem("sttApprove");
        let balance = window.localStorage.getItem("balance");
        setSttApprove(stt);
        setBalance(balance);

        // console.log(stt, balance);

        // console.log(data);
      } catch (error) {
        console.error("Error checking staking approval:", error);
      }
    };

    intervalRef.current = setInterval(fetchData, 1000);

    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, []);

  const coppy = () => {
    navigator.clipboard.writeText(window.location.origin + '/login?ref=' + user?.userAddress);
    NotificationManager.success("Coped", "Success", 5000);
  }

  const _approve = async () => {
    setLoading(true);
    let data = await submitApproveStaking();
    // console.log(data);
    if (!data) {
    }
    setLoading(false);
  }

  const _vote = async () => {
    setLoading(true);
    let data = await staking(newLevel);
    if (!data) {
      NotificationManager.error("Error", "Error", 10000);
    } else {
      NotificationManager.success("Give Success", "Success", 10000);
    }
    setLoading(false);
  }

  return (
    <div className="vote-page">
      <h1 className="title">Give</h1>

      <div className="vote-box">
        <div className="ooooawfsdasa">
          <div className="label">Your current level</div>
          <div className="value">{user?.amount / (40 * 1e18)}</div>
        </div>

        <div className="label">Enter new level</div>
        <div className="input-group">
          <input
            type="number"
            value={newLevel}
            onChange={(e) => setNewLevel(Number(e.target.value))}
            min={1}
          />
          <button onClick={() => setNewLevel(10)}>MAX</button>
        </div>

        {
          loading ? (
            <LoadingButton className="btn btn-primary" />
          ) : (
            sttApprove == "true" ?
              <button className="approve-btn" onClick={_vote}>Give</button>
              :
              <button className="approve-btn" onClick={_approve}>Agree</button>
          )
        }

        <div className="price">
          Total Price: <span>{totalPrice} USDT</span>
        </div>
      </div>

      <div className="team-box">
        <h2 className="team-title">Team management</h2>
        <div className="team-info">
          <div className="row"><span>Sponsor</span><span>{user?.ref?.slice(0, 5)}...{user?.ref?.slice(-5)}</span></div>
          <div className="row"><span>Total F1</span><span>{user?.totalF1}</span></div>
          <div className="row"><span>Total Member</span><span>{user?.total_members}</span></div>
          <div className="row"><span>Total Gives</span><span>{user?.total_votes}</span></div>
          <div className="row">
            <span>Referral Link</span>
            <span>
              <button onClick={() => coppy()}>📋</button>
              https://...{user?.userAddress?.slice(-8)}
            </span>
          </div>
          <div className="row"><span>Claimed</span><span>{formatNumber(user?.total_receive / 1e18)} USDT</span></div>
          {/* <div className="row"><span>Remaining</span><span>{formatNumber((user?.amount * 3 / 1e18) - (user?.total_receive / 1e18))} USDT</span></div> */}
          <div className="row flex items-center gap-2">
            <span>Remaining</span>

            <div className="flex gap-1">
              {(() => {
                const remaining =
                  (user?.amount * 3) / 1e18 - (user?.total_receive / 1e18);

                let color = "green"; 
                if (remaining < 10) {
                  color = "red";
                } else if (remaining < 20) {
                  color = "yellow";
                }

                return [1].map((i) => (
                  <span
                    key={i}
                    style={{
                      display: "inline-block",
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      backgroundColor: color,
                    }}
                  />
                ));
              })()}
            </div>

            <span>
              {formatNumber(
                (user?.amount * 3) / 1e18 - user?.total_receive / 1e18
              )}{" "}
              USDT
            </span>
          </div>
        </div>
      </div>
      {/* <img className="title-bg" style={{ marginTop: 50 }} alt="" src="https://funky.wiki/assets/bg-home-active-bot.png"></img> */}

      <div className="team-box" style={{ maxWidth: 600 }}>
        <h2 className="team-title">F1 Members</h2>
        <div className="team-info">
          {
            dataF1?.map(dt => {
              return (
                <div >
                  <span>{dt?.f1Addresses?.slice(0, 5)}...{dt?.f1Addresses?.slice(-5)}</span>
                  <span>  F1: {0}</span>
                  <span>  LV: {0}</span>
                  <span>  Bonus: ${formatNumber(dt?.totalReceives / 1e18)}/${formatNumber(dt?.amounts * 3 / 1e18)}</span>
                </div>
              )
            })
          }

        </div>
      </div>
      {/* <img className="title-bg" style={{ marginTop: 50 }} alt="" src="https://funky.wiki/assets/bg-home-active-bot.png"></img> */}
      <div className="kkkksadsad098f8qwsad">
        <div className="p-4 bg-black min-h-screen text-white" style={{ marginTop: 50 }}>
          <h1 className="text-2xl font-bold mb-6">MLM Tree</h1>
          {treeData.map((node, idx) => (
            <TreeNode key={idx} node={node} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Staking;